<div class="request-container">
  <div class="close" (click)="dialogRef.close()">
    <img src="assets/icons/news/close.svg" alt="close modal" />
  </div>
  <img src="/assets/icons/confirm.svg" alt="success_logo" />

  <p class="info-title">{{ data.title }}</p>

  <div class="transfer-info">
    <div class="row">
      <h3 class="subtitle">Cambiaste</h3>
      <div class="coin-info">
        <p class="recieve-coin">
          {{ data.srcCoinAmount | formatCoinAmount : data.srcCoin }} {{ data.srcCoin }}
          <img
            src="assets/icons/info.svg"
            *ngIf="data.custodyFee"
            [matTooltip]="
              '-' +
              formatNumber.transform(data.custodyFee, [2, 8]) +
              ' aUST fee de acceso al servicio'
            "
            [matTooltipPosition]="'above'"
          />
        </p>
        <img [src]="'/assets/icons/crypto/' + data.srcCoin.toLowerCase() + '.svg'" alt="srcCoin" />
      </div>
    </div>

    <!-- <div class="divider"></div> -->

    <div class="row">
      <h3 class="subtitle">Recibiste</h3>
      <div class="coin-info">
        <p class="recieve-coin">
          {{ data.destCoinAmount | formatCoinAmount : data.destCoin }} {{ data.destCoin }}
        </p>
        <img
          [src]="'/assets/icons/crypto/' + data.destCoin.toLowerCase() + '.svg'"
          alt="destCoin"
        />
      </div>
    </div>
  </div>
  <ng-container *ngIf="data.isGroup; else notGroup">
    <div class="container-btn-group" *ngIf="data.isGroup">
      <button class="td-btn primary" (click)="goDashboard()">Volver al dashboard</button>
    </div>
  </ng-container>
  <ng-template #notGroup>
    <button class="history-btn" (click)="operationBtnClicked()">
      <img src="assets/icons/link-white.svg" alt="link" />
      Ver operación
    </button>
  </ng-template>
</div>
